// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","button_white":"Button_button_white__zEY0R","button_black":"Button_button_black__Yqu6I"};